import classNames from "classnames";
import { ReactElement } from "react";
import styles from "./ActionListDivider.module.less";

export type ActionListDividerProps = {
	isVisibleOnMobile?: boolean;
};

export const ActionListDivider = (props: ActionListDividerProps): ReactElement => {
	const {
		isVisibleOnMobile = true
	} = props;

	return (
		<li
			className={classNames(
				styles.root,
				{
					[styles.root_notVisibleOnMobile]: !isVisibleOnMobile
				}
			)}
		/>
	);
};
ActionListDivider.displayName = "ActionListDivider";
